import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import classNames from 'classnames';

import css from './PlayableIndication.css';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import Tooltip from '../molecules/Tooltip';

export const HOVER_INDICATION_TEXT = 'STATIC.CREATIVES.PLAYABLE_HOVER_INDICATION';
const CLICK_INDICATION_TEXT = 'STATIC.CREATIVES.PLAYABLE_CLICK_INDICATION';

export const IndicationType = {
    HOVER: 'hover',
    CLICK: 'click',
};

const AttributesByType = {
    [IndicationType.HOVER]: {
        text: HOVER_INDICATION_TEXT,
        icon: 'hand-move',
    },
    [IndicationType.CLICK]: {
        text: CLICK_INDICATION_TEXT,
        icon: 'hand-click',
    },
};

const PlayableIndication = forwardRef(
    ({ className, translate, type, iconSize = IconSizes.LARGE, showTooltip = false, showText = true }, ref) => {
        const { text, icon } = AttributesByType[type || IndicationType.HOVER];

        const IndicationIcon = <Icon variant={IconVariants.LIGHT} name={icon} size={iconSize} />;

        return (
            <div ref={ref} className={classNames(css.container, className)}>
                {showTooltip ? (
                    <Tooltip wrapperClass={css.tooltipContainer} title={translate(text)}>
                        {IndicationIcon}
                    </Tooltip>
                ) : (
                    IndicationIcon
                )}
                {showText && <div className={css.text}>{translate(text)}</div>}
            </div>
        );
    }
);

PlayableIndication.propTypes = {
    translate: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.oneOf(Object.values(IndicationType)),
    iconSize: PropTypes.oneOf(Object.values(IconSizes)),
    showTooltip: PropTypes.bool,
    showText: PropTypes.bool,
};

export default withLocalize(PlayableIndication);
